export enum TransactionStatusEnum {
  // 未受領
  NOT_RECEIVED_YET = '01',
  // 受領済み
  RECEIVED = '02',
  // 受領拒否
  UNACCEPTED = '03',
  // 送信取消
  SENT_CANCELED = '04',
}
